exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".emptyCard-9a3e3d14{display:flex;flex-direction:column;justify-content:flex-start}.secondaryColCard-1d6a72ea>a{font-weight:500}.emptyTop-1397f3e6{display:flex;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"emptyCard": "emptyCard-9a3e3d14",
	"secondaryColCard": "secondaryColCard-1d6a72ea",
	"emptyTop": "emptyTop-1397f3e6"
};